import $ from 'jquery';

const backPage = $('.js-back-to-models');
const currentUrl = new URL(window.location);
const urlEndpoint = new URL('/' + localStorage.getItem('myShowroom'), currentUrl.origin);

if (currentUrl.searchParams.has('lang')) {
  urlEndpoint.searchParams.set('lang', currentUrl.searchParams.get('lang'));
}

backPage.attr('href', urlEndpoint.toString());
